import ISKFormat from '@/components/common/ISKFormat';
import { Paragraph } from 'components/src/typography';
import * as React from 'react';

type Props = {
  title: string;
  price: number;
};

const PriceListItem = ({ title, price }: Props) => {
  const hasDecimal = !Number.isInteger(price);

  return (
    <div className="flex justify-between">
      <Paragraph>{title}</Paragraph>
      {hasDecimal || price ? (
        <Paragraph>{`${price ?? 0} kr.`}</Paragraph>
      ) : (
        <ISKFormat value={price} renderText={(formattedValue) => <Paragraph>{formattedValue}</Paragraph>} />
      )}
    </div>
  );
};
export default PriceListItem;
